(ns guidebook.views
  (:import
   [goog.events EventType])
  (:require
   [reagent.core :as r]
   [very.re-frame.core :as rf :refer [>evt]]
   [goog.events]
   [goog.style]
   [cljss.core :as cljss]
   [css.core :as css
    :refer [class-names get-theme]
    :refer-macros [defstyled]]
   [guidebook.views.alignment :as alignment]
   [guidebook.views.balance-sheet :as balance-sheet]
   [guidebook.views.cash-flow :as cash-flow]
   [guidebook.views.cover-page :as cover-page]
   [guidebook.views.family-profile :as family-profile]
   [guidebook.views.financial-priorities :as financial-priorities]
   [guidebook.views.footer :as footer]
   [guidebook.views.investment-proposal :as investment-proposal]
   [guidebook.views.key-considerations :as key-considerations]
   [guidebook.views.legacy-planning :as legacy-planning]
   [guidebook.views.notes :as notes]
   [guidebook.views.our-process :as our-process]
   [guidebook.views.priority-actions :as priority-actions]
   [guidebook.views.risk-profile :as risk-profile]
   [guidebook.views.stress-test-results :as stress-test-results]
   [guidebook.views.strategies :as strategies]
   [guidebook.views.value-relationships :as value-relationships]
   [guidebook.views.performance :as performance]
   [guidebook.views.review :as review]
   [guidebook.views.risk-questionnaire :as risk-questionnaire]
   [loader.views :as loader]))

(defstyled menu-navigation-s :nav
  {:background-color "white"
   :border-bottom "1px solid #dbdbdb"
   :height "52px"
   :z-index "999"
   :display (with-meta #(if %
                          "none"
                          "flex")
              :hidden?)
   :align-items "center"
   :justify-content "flex-end"
   :position (with-meta #(if %
                           "fixed"
                           "relative")
               :sticky?)
   :visibility (with-meta #(if %
                             "hidden"
                             "visible")
                 :invisible?)
   :width (with-meta #(or % "100%")
            :width)
   :top 0
   :text-align "right"
   :padding "0 100px"})

(defstyled navigation-link-wrapper-s :div
  {:position "relative"
   :display "flex"
   :align-items "center"})

(defstyled menu-navigation-link-s :span
  {:margin-right "62px"
   :font-size "20px"
   :display "inline-block"
   :font-weight "300"
   :color "black"
   :text-decoration (with-meta #(if % "underline" "none") :active?)
   :cursor "pointer"
   :opacity (with-meta #(if % "1" ".6") :active?)
   :&:hover {:opacity "1"}
   :transition "opacity .25s"
   :&:last-child {:margin-right "0"
                  :width "28px"
                  :height "28px"
                  :background-image "url(/assets/icons/notes.svg)"
                  :background-repeat "no-repeat"
                  :background-size "contain"}})

(defstyled header-s :section
  {::cljss/media {[:print]
                  {:display "none"}}})

(defn filter-pages [exclude pages]
  (let [exclude-set (set (map keyword exclude))
        pages-set (set pages)]
    (seq (clojure.set/difference pages-set exclude-set))))

(defn header []
  (let [notes-modal (rf/subscribe [:guidebook/notes-modal])
        toggle-notes-modal #(>evt [:guidebook/toggle-notes-modal])
        nav-click (fn [kw]
                    (.scrollIntoView (.getElementById js/document (name kw)) (clj->js {:block "start"
                                                                                       :behavior "smooth"})))]
    (fn [{:keys [current sticky nav-items]}]

      [header-s
      ;; This is a navigation placeholder that is invisible so that when
      ;; we scrollIntoView, the offset doesn't have to be calculated again
       [:div
        [menu-navigation-s {:invisible? false
                            :hidden? (not sticky)}
         (into [:div] (map #(menu-navigation-link-s (last %)) nav-items))]]
       [menu-navigation-s {:id "nav" :sticky? sticky}
        [navigation-link-wrapper-s
         (when (:open? @notes-modal)
           [notes/main {:close toggle-notes-modal} (:submitting? @notes-modal)])
         (for [[kw label] nav-items]
           ^{:key kw}
           [menu-navigation-link-s {:on-click #(nav-click kw)
                                    :active? (= kw current)} label])
         [menu-navigation-link-s {:on-click toggle-notes-modal}]]]])))

(defstyled page-s :section
  {:position "relative"
   :width "100%"
   :background "white"
   :min-height "100vh"
   :page-break-before "always"
   ::cljss/media {[:print]
                  {:min-width "1190px"
                   :display (with-meta #(if % "none" "block") :hide?)}}})

(defstyled page-break-s :div
  {:page-break-before "always"})

(defstyled page-extend-s :div
  {:position "absolute"
   :bottom "0"})

(defn page-builder [{:keys [page id footer-hide footer-left footer-right print-hide?]}]
  [page-s {:id id
           :hide? print-hide?}
   [page]
   [page-break-s]
   [page-extend-s]
   (when (not footer-hide) [footer/main {:footer-left footer-left :footer-right footer-right}])])

(def page-keys
  {:review 0
   :key-considerations 1
   :process 2
   :relationship 3
   :family-profile 4
   :priorities 5
   :risk 6
   :alignment 7
   :cash-flow 8
   :balance 9
   :legacy-planning 10
   :risk-questionnaire 11
   :proposal 12
   :stress-test 13
   :performance 14
   :strategies 15
   ; :investment-mapping 16
   ; :alignment 17
   ; :legacy-planning 18
   :priority-actions 19})


(def pages
  {:alignment {:page alignment/main}
   :balance {:page balance-sheet/main :print-hide? true}
   :cash-flow {:page cash-flow/main :print-hide? true}
   :family-profile {:page family-profile/main :footer-left "white" :footer-right "white"}
   :key-considerations {:page key-considerations/main}
   :legacy-planning {:page legacy-planning/main}
   :priorities {:page financial-priorities/main}
   :priority-actions {:page priority-actions/main}
   :process {:page our-process/main}
   :proposal {:page investment-proposal/main}
   :relationship {:page value-relationships/main :footer-left "white" :footer-right "white"}
   :risk {:page risk-profile/main}
   :stress-test {:page stress-test-results/main}
   :strategies {:page strategies/main}
   :performance {:page performance/main}
   :review {:page review/main :footer-left "white" :footer-right "white"}
   :risk-questionnaire {:page risk-questionnaire/main}})


(def nav-items
  {:relationship "Life's Moments"
   :priorities "Priorities"
   :risk "Risk"
   :cash-flow "Cash Flow"
   :balance "Balance"})

(defn main []
  (r/with-let [page (rf/subscribe [:guidebook/page])
               uri-params (rf/subscribe [:router/uri-params])
               sticky (r/atom false)
               within-page (fn [id]
                             (if-let [el (.getElementById js/document (name id))]
                               (let [el-offset (goog.style/getFramedPageOffset el)
                                     el-top (.-y el-offset)
                                     el-size (goog.style/getSize el)
                                     el-height (.-height el-size)
                                     el-bottom (+ el-top el-height)]
                                 (and (not= @page id) (and (<= el-top 0)) (>= el-bottom 0)))
                               false))
               set-unsticky (fn []
                              (when @sticky
                                (>evt [:guidebook/set-page nil]))
                              (reset! sticky false))
               set-sticky (fn []
                            (doseq [kw (keys page-keys)]
                              (when (within-page kw)
                                (>evt [:guidebook/set-page kw])))
                            (reset! sticky true))
               handle-scroll (fn [e]
                               (let [cover-page (.getElementById js/document "cover-page")
                                     cover-page-size (goog.style/getSize cover-page)
                                     cover-page-height (.-height cover-page-size)
                                     cover-page-offset (goog.style/getFramedPageOffset cover-page)
                                     cover-page-top (+ (.-y cover-page-offset) cover-page-height)
                                     nav (.getElementById js/document "nav")
                                     nav-offset (goog.style/getFramedPageOffset nav)
                                     nav-top (.-y nav-offset)]
                                 (cond
                                   (>= cover-page-top 0) (set-unsticky)
                                   (<= nav-top 0) (set-sticky))))
               _ (goog.events/listen js/window EventType.SCROLL handle-scroll)]
    (let [filtered-page-keys (filter-pages (or (@uri-params "exclude[]") []) (keys page-keys))
          ordered-pages (sort-by page-keys filtered-page-keys)
          filtered-nav-items (select-keys nav-items filtered-page-keys)
          ordered-nav-items (sort-by (fn [[k _]] (get page-keys k)) filtered-nav-items)]
      [:div
       [loader/page]
       [page-builder {:page cover-page/main
                      :id "cover-page"
                      :footer-hide true}]
       [header {:current @page
                :sticky @sticky
                :nav-items ordered-nav-items}]
       (for [page ordered-pages]
         [:div {:key (name page)}
          [page-builder (merge {:id (name page)} (get pages page))]])])
    (finally
      (goog.events/unlisten js/window EventType.SCROLL handle-scroll))))
